import { DISABLED_OPACITY as n } from "../../../../styles/colors/consts.js";
function l({
  width: t,
  fillHeight: e,
  accessibilityLabel: r,
  disabled: o,
  loading: i
}) {
  return {
    display: "block",
    width: t,
    height: e ? "100%" : void 0,
    "aria-label": r,
    fontWeight: "bold",
    textDecoration: "none",
    cursor: o ? "not-allowed" : i ? "progress" : "pointer",
    opacity: o ? n : "1"
  };
}
export {
  l as default
};
